//
//
//
//
//
//
//
//
//
//
//

import Frame from './components/frame'
import { Share } from '@/utils/commonUtils'
import { store } from "@/observable/store"
  export default {
    data() {
      return {
        // key: value
        value:'我叫王美丽，三天前，我拉黑了许久未联系的高中同学小A。原因是她竟拉我去做黑医美！如果是你，你能发现其中的马脚吗？',
        iconSrc:'https://static.soyoung.com/sy-pre/index-1596103800731.gif'
      }
    },
    components: {
      Frame
    },
    mounted () {
      let obj ={
          'shareTitle':'瘦脸针避坑挑战Come on！',
          'shareContent':  '想要小V脸、一字肩？闯关答题还能赢MAC口红哦~',
          'shareTimelineContent':'瘦脸针避坑挑战Come on！',
          'shareUrl': `https://${window.location.host}/riskGames?activityId=game&from_action=game_url`,
          'shareImgurl': 'https://static.soyoung.com/sy-pre/shareicon-1596528600703.png',
          'rightBtnStatus': 1
      }
      Share(obj,'sybao_ins_activity_share_result_sys',obj);

      this.STATISTICS('load','sybao_ins_activity_first_page');
    },
    methods: {
      start() {
      this.STATISTICS('click','sybao_ins_activity_first_start_click');
        this.$router.push({
            path: "/answer",
            query:{
                flag : 'postdisable',
            }
        });
      },
    },
  }
